// extracted by mini-css-extract-plugin
module.exports = {"overlay":"MediaLightbox_overlay__DxzUq","content":"MediaLightbox_content__rzxnn","fade":"MediaLightbox_fade__PxtqP"};